import { Id } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { preferenceService } from "./preferenceService";

const preferencesFetcher = () => preferenceService.all().then((r) => r.data.data);
export const usePreferencesQuery = () => {
	return useQuery({ queryKey: preferenceService.allKey, queryFn: preferencesFetcher });
};

const preferenceFetcher = (preferenceId: Id) => () => preferenceService.show(preferenceId).then((r) => r.data.data);
export const usePreferenceQuery = (preferenceId: Id) => {
	const { data, isLoading, refetch } = useQuery({
		queryKey: preferenceService.showKey(preferenceId),
		queryFn: preferenceFetcher(preferenceId),
	});

	return {
		data,
		isLoading,
		refetch,
	};
};
